<template>
  <div class="app min-h-screen flex flex-col font-sans">
    <!-- Main Content -->
    <div class="main-content flex-1 bg-gradient-to-r from-gray-100 to-blue-50">
      <router-view />
    </div>
    <!-- ✅ Footer -->
    <footer class="bg-white text-center py-6 text-base text-gray-600">
      © {{ currentYear }} Web Diagnostic Tool | by
      <a
        href="https://www.proweaver.com/"
        target="_blank"
        class="text-blue-500 hover:underline"
        >Proweaver</a
      >
    </footer>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import { useRoute } from "vue-router";
export default {
  data() {
    return {
      isCollapsed: false,
    };
  },
  setup() {
    const route = useRoute();

    const currentYear = new Date().getFullYear();

    // ✅ Check if user is authenticated
    const isAuthenticated = computed(() => !!localStorage.getItem("token"));
    // Show SideNavigation and Header only if the route is not '/login'
    const showSideNavigation = computed(() => route.path !== "/");
    // State for collapsing SideNavigation
    const isSideNavCollapsed = ref(false);
    const toggleSideNavigation = () => {
      isSideNavCollapsed.value = !isSideNavCollapsed.value;
    };

    return {
      currentYear,
      showSideNavigation,
      isSideNavCollapsed,
      toggleSideNavigation,
      isAuthenticated,
    };
  },
};
</script>

<style lang="scss">
.app {
  display: flex;
  flex-direction: column; /* Stack header at the top */
  min-height: 100vh; /* Full height for the app */
}

.main-layout {
  display: flex;
  flex: 1; /* Occupy the remaining space after the header */
}

.main-content {
  flex: 1; /* Occupy the rest of the space after SideNavigation */
  transition: margin-left 0.3s ease-in-out;
}

.main-content.ml-16 {
  margin-left: 4rem; /* Adjust main content margin when SideNavigation is collapsed */
}
</style>
